import { HTMLAttributes, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useCookieBanner } from 'hooks';
import { styled } from 'netline-ui';
import { CloseableComponentProps } from 'types';

import PreferencesListItem from '../PreferencesPopup/PreferencesListItem';

type CookieSettingsProps = CloseableComponentProps & HTMLAttributes<HTMLLIElement>;

const MobileCookieSettingsRootRoot = styled('div')(({ theme: { spacing } }) => ({
  '.MuiDialog-paper': {
    margin: spacing(1),
  },
}));

const MobileCookieSettings = ({ onMenuClose }: CookieSettingsProps) => {
  const { t } = useTranslation();
  const { openSettings } = useCookieBanner();
  const handleCookieSettingsClick = useCallback(() => {
    openSettings();
    onMenuClose?.();
  }, [onMenuClose, openSettings]);

  return (
    <MobileCookieSettingsRootRoot>
      <PreferencesListItem title={t('cookie.settings_btn')} handleClick={handleCookieSettingsClick} />
    </MobileCookieSettingsRootRoot>
  );
};

export default MobileCookieSettings;
